var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("main", { staticClass: "main" }, [
    _c("div", { staticClass: "grid-container" }, [
      _c("div", { staticClass: "action action--page" }, [
        _c("h1", { staticClass: "u-no-margin" }, [
          _vm._v(_vm._s(_vm.$t("kolonne.title"))),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "grid-container" }, [
      _c("div", { staticClass: "grid-x align-center" }, [
        _c(
          "div",
          { staticClass: "cell small-auto medium-9 large-5" },
          [
            _c("v-action-buttons", {
              attrs: { items: _vm.getActionButtons },
              on: { actionClicked: _vm.onClickActionButton },
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "dialog",
                class: { active: _vm.showCreateUpdateDialog },
              },
              [
                _c("div", { staticClass: "dialog--content" }, [
                  _c("h3", [_vm._v(_vm._s(_vm.createUpdateDialogTitle))]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", [_vm._v(_vm._s(_vm.$t("kolonne.number")))]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.object.number,
                          expression: "object.number",
                        },
                      ],
                      attrs: { type: "text", name: "number" },
                      domProps: { value: _vm.object.number },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.object, "number", $event.target.value)
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "text-center" }, [
                    _c(
                      "button",
                      {
                        staticClass: "button",
                        on: {
                          click: function ($event) {
                            return _vm.onSaveKolonne()
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("save")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "button gray",
                        on: {
                          click: function ($event) {
                            return _vm.onCloseCreateUpdateDialog()
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("cancel")))]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "close-button",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.onCloseCreateUpdateDialog()
                        },
                      },
                    },
                    [
                      _c("span", { attrs: { "aria-hidden": "true" } }, [
                        _vm._v("×"),
                      ]),
                    ]
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("v-form-message", {
              attrs: {
                type: "success",
                id: "form-success",
                message: _vm.objectSuccess,
                autoCloseTimeout: 0,
              },
              on: { onClickAction: _vm.onClickSuccessDialogAction },
            }),
            _vm._v(" "),
            _c("v-form-message", {
              attrs: {
                type: "default",
                message: _vm.removeConfirm,
                autoCloseTimeout: 0,
                showActionButtons: true,
              },
              on: { onClickAction: _vm.onClickDeleteDialogAction },
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "box u-extra-large-padding--bottom u-extra-medium-padding--top",
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "table-wrapper loading-wrapper",
                    class: { "is-loading": _vm.tableLoading },
                  },
                  [
                    _c(
                      "table",
                      { staticClass: "table table-striped" },
                      [
                        _c("thead", { staticClass: "thead-dark" }, [
                          _c("tr", [
                            _c("th", { attrs: { scope: "col" } }, [
                              _vm._v(_vm._s(_vm.$t("kolonne.number"))),
                            ]),
                            _vm._v(" "),
                            _c("th", { attrs: { scope: "col" } }),
                            _vm._v(" "),
                            _c("th", { attrs: { scope: "col" } }),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "draggable",
                          {
                            attrs: { tag: "tbody" },
                            on: { end: _vm.onReorderKolonneTableItems },
                            model: {
                              value: _vm.tableItems,
                              callback: function ($$v) {
                                _vm.tableItems = $$v
                              },
                              expression: "tableItems",
                            },
                          },
                          _vm._l(_vm.tableItems, function (row) {
                            return _c(
                              "tr",
                              { key: row.id, staticClass: "draggable" },
                              [
                                _c("td", [_vm._v(_vm._s(row.number))]),
                                _vm._v(" "),
                                _c("td", { staticStyle: { width: "46px" } }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "button button--action button--action--edit button--small",
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.onOpenCreateUpdateDialog(
                                            row.id,
                                            row.number
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("update")))]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("td", { staticStyle: { width: "46px" } }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "button button--action button--action--delete button--small",
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.onOpenDeleteDialog(
                                            row.id,
                                            row.number
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("delete")))]
                                  ),
                                ]),
                              ]
                            )
                          }),
                          0
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.tableLoading
                      ? _c("div", { staticClass: "loading-message" }, [
                          _vm._v(_vm._s(_vm.$t("results_loading"))),
                        ])
                      : _vm._e(),
                  ]
                ),
              ]
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }